import { useState, useRef, useEffect } from "react";

function CustomSelect({
  value,
  options,
  onChange,
  item,
  isHovered,
  onHover,
  params,
  currentVal,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [currentValue, setCurrentValue] = useState(currentVal || 0);
  const selectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (newValue) => {
    onChange && onChange(newValue, item);
    setIsOpen(false);
    setCurrentValue(newValue);
  };

  return (
    <div className="custom-select-container" ref={selectRef}>
      <button
        type="button"
        className={`data-table-select ${
          isHovered ? "custom-select-button-hover" : ""
        } ${value !== undefined ? `data-table-select-${value}` : ""}
        ${params?.buttonClass ? params.buttonClass : ""}
        ${isOpen && params?.buttonClassOpened ? params.buttonClassOpened : ""}
        `}
        onClick={() => setIsOpen(!isOpen)}
        onMouseEnter={() => onHover && onHover(item?.id)}
        onMouseLeave={() => onHover && onHover(null)}
      >
        {isHovered !== undefined ? (
          !isHovered ? (
            options[value]
          ) : (
            "Указать"
          )
        ) : params?.optionsClassName?.collapse ? (
          <span
            title={options[currentValue]}
            className={params.optionsClassName.collapse}
          >
            {options[currentValue]}
          </span>
        ) : (
          options[currentValue]
        )}
        {params?.arrow?.isNeed ? (
          <img
            src={isOpen ? params.arrow.close : params.arrow.open}
            alt={isOpen ? "Свернуть" : "Развернуть"}
            className="custom-select-arrow"
          />
        ) : null}
      </button>

      {isOpen && (
        <div
          className="custom-select-dropdown"
          style={value === undefined ? { width: "calc(100% - 10px)" } : {}}
        >
          {options.map((label, index) => (
            <div
              key={index}
              className={`custom-select-option ${
                value && index === value ? "selected" : ""
              } ${
                params?.optionsClassName?.base
                  ? params.optionsClassName.base
                  : ""
              }
               ${
                 params?.optionsClassName?.[index]
                   ? params.optionsClassName[index]
                   : ""
               }`}
              onClick={() => handleSelect(index)}
            >
              {params?.optionsClassName?.collapse ? (
                <span
                  title={label}
                  className={params.optionsClassName.collapse}
                >
                  {label}
                </span>
              ) : (
                label
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CustomSelect;
